import { Query } from '../../design-system/types';

export function parseQueryString(queryString: string): Query {
    const params = new URLSearchParams(queryString);

    return Array.from(params.entries()).reduce<Query>((acc, [key, value]) => {
        const decodedValue = value === '' ? null : value;

        if (key in acc) {
            if (Array.isArray(acc[key])) {
                acc[key].push(decodedValue as string);
            } else {
                acc[key] = [acc[key] as string, decodedValue as string];
            }
        } else {
            acc[key] = decodedValue;
        }

        return acc;
    }, {});
}

type StringifyOptions = {
    encode: boolean;
};

type QueryToStringify = { [key: string]: string | string[] | null | undefined };

export function stringifyQuery(
    query: QueryToStringify,
    options: StringifyOptions = { encode: true },
): string {
    const params = new URLSearchParams();

    function append(key: string, value: string): void {
        params.append(
            options.encode ? encodeURIComponent(key) : key,
            options.encode ? encodeURIComponent(value) : value,
        );
    }

    Object.keys(query).forEach((key) => {
        const value = query[key];
        if (Array.isArray(value)) {
            value.forEach((val) => {
                append(key, val);
            });
        } else if (value !== null && value !== undefined) {
            append(key, value);
        }
    });

    return params.toString();
}
